export default "__VITE_ASSET__9f5720b8__"